import { createRouter, createWebHistory } from 'vue-router';
import { routes, handleHotUpdate } from 'vue-router/auto-routes';
import qs from 'qs';

export const router = createRouter({
    history: createWebHistory(),
    routes,
    parseQuery: (query) => qs.parse(query),
    stringifyQuery: (query) => Object.keys(query).length ? qs.stringify(query) : ''
});

router.beforeEach(async (to, _, next) => {
    const matched = to.matched.at(-1).components.default;
    if (matched?.layout === 'error')
        return next();
    const auth = useAuthStore();
    if (to.query.login_token) {
        let query = { ...to.query };
        await auth.loginWithToken(query.login_token);
        delete query.login_token;
        router.replace({ query });
    }
    await auth.fetchUser();
    let authFlag = matched?.auth ?? 'loggedIn';
    if (authFlag === 'loggedIn' && !auth.loggedIn) {
        auth.setUniversal(to.fullPath);
        return next('/login');
    }
    if (authFlag === 'guest' && auth.loggedIn)
        return next('/');

    const system = useSystemStore();
    let functions = [system.setSystemSettings()];
    if (auth.loggedIn)
        functions.push(system.setSystemDefaults());
    if (auth.user.full_admin)
        functions.push(system.setGlobalSettings());
    await Promise.all(functions);
    const validate = matched?.validate;
    if (!validate || validate({ auth: useAuthStore(), system: useSystemStore(), rbac: useRbac() }))
        return next();
    next('/404')
});

if (import.meta.hot)
    handleHotUpdate(router);

export default router;
